export default handler

function handler(value) {
  if (typeof (value) !== 'number') return value
  return value.toLocaleString()
}